import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['MeasurementPoint'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasurementPointById: build.query<GetMeasurementPointByIdApiResponse, GetMeasurementPointByIdApiArg>({
        query: (queryArg) => ({ url: `/MeasurementPoint/${queryArg}` }),
        providesTags: ['MeasurementPoint'],
      }),
      deleteMeasurementPointById: build.mutation<
        DeleteMeasurementPointByIdApiResponse,
        DeleteMeasurementPointByIdApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementPoint/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['MeasurementPoint'],
      }),
      getMeasurementPointGetAll: build.query<GetMeasurementPointGetAllApiResponse, GetMeasurementPointGetAllApiArg>({
        query: () => ({ url: `/MeasurementPoint/get-all` }),
        providesTags: ['MeasurementPoint'],
      }),
      getMeasurementPointGetAllBySubstation: build.query<
        GetMeasurementPointGetAllBySubstationApiResponse,
        GetMeasurementPointGetAllBySubstationApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasurementPoint/get-all-by-substation`,
          params: {
            substationId: queryArg,
          },
        }),
        providesTags: ['MeasurementPoint'],
      }),
      getMeasurementPointGetPastVersionsByTechnicalName: build.query<
        GetMeasurementPointGetPastVersionsByTechnicalNameApiResponse,
        GetMeasurementPointGetPastVersionsByTechnicalNameApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementPoint/get-past-versions/${queryArg}` }),
        providesTags: ['MeasurementPoint'],
      }),
      getMeasurementPointByIdIsReferenced: build.query<
        GetMeasurementPointByIdIsReferencedApiResponse,
        GetMeasurementPointByIdIsReferencedApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementPoint/${queryArg}/is-referenced` }),
        providesTags: ['MeasurementPoint'],
      }),
      getMeasurementPointByIdHasData: build.query<
        GetMeasurementPointByIdHasDataApiResponse,
        GetMeasurementPointByIdHasDataApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementPoint/${queryArg}/has-data` }),
        providesTags: ['MeasurementPoint'],
      }),
      getMeasurementPointByIdHasDataForCurrentVersion: build.query<
        GetMeasurementPointByIdHasDataForCurrentVersionApiResponse,
        GetMeasurementPointByIdHasDataForCurrentVersionApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementPoint/${queryArg}/has-data-for-current-version` }),
        providesTags: ['MeasurementPoint'],
      }),
      postMeasurementPointNewVersionByMeasurementPointTechnicalName: build.mutation<
        PostMeasurementPointNewVersionByMeasurementPointTechnicalNameApiResponse,
        PostMeasurementPointNewVersionByMeasurementPointTechnicalNameApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementPoint/new-version/${queryArg}`, method: 'POST' }),
        invalidatesTags: ['MeasurementPoint'],
      }),
      postMeasurementPoint: build.mutation<PostMeasurementPointApiResponse, PostMeasurementPointApiArg>({
        query: (queryArg) => ({ url: `/MeasurementPoint`, method: 'POST', body: queryArg }),
        invalidatesTags: ['MeasurementPoint'],
      }),
      putMeasurementPoint: build.mutation<PutMeasurementPointApiResponse, PutMeasurementPointApiArg>({
        query: (queryArg) => ({ url: `/MeasurementPoint`, method: 'PUT', body: queryArg }),
        invalidatesTags: ['MeasurementPoint'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementPointApi };
export type GetMeasurementPointByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointExternalDto;
export type GetMeasurementPointByIdApiArg = number;
export type DeleteMeasurementPointByIdApiResponse = unknown;
export type DeleteMeasurementPointByIdApiArg = number;
export type GetMeasurementPointGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointExternalDto;
export type GetMeasurementPointGetAllApiArg = void;
export type GetMeasurementPointGetAllBySubstationApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointExternalDto;
export type GetMeasurementPointGetAllBySubstationApiArg = /** Optional id of substation */ number | undefined;
export type GetMeasurementPointGetPastVersionsByTechnicalNameApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointVersionExternalDto;
export type GetMeasurementPointGetPastVersionsByTechnicalNameApiArg =
  /** Technical name of the measurement point */ string;
export type GetMeasurementPointByIdIsReferencedApiResponse = /** status 200 OK */ boolean;
export type GetMeasurementPointByIdIsReferencedApiArg = /** Measurement point ID */ number;
export type GetMeasurementPointByIdHasDataApiResponse = /** status 200 OK */ boolean;
export type GetMeasurementPointByIdHasDataApiArg = /** Measurement point ID */ number;
export type GetMeasurementPointByIdHasDataForCurrentVersionApiResponse = /** status 200 OK */ boolean;
export type GetMeasurementPointByIdHasDataForCurrentVersionApiArg = /** Measurement point ID */ number;
export type PostMeasurementPointNewVersionByMeasurementPointTechnicalNameApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointVersionExternalDto;
export type PostMeasurementPointNewVersionByMeasurementPointTechnicalNameApiArg =
  /** Technical name of measurement point name */ string;
export type PostMeasurementPointApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointExternalDto;
export type PostMeasurementPointApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementPointExternalDto;
export type PutMeasurementPointApiResponse = unknown;
export type PutMeasurementPointApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementPointExternalDto;
export type ApiDatabaseCommonConnectionPointType = 0 | 1 | 2;
export type ApiCommonExternalDtoMeasurementPointExternalDto = {
  id?: number;
  tsoId?: number;
  name: string;
  technicalName: string;
  substationId: number;
  transducerModelVoltage1Id: number;
  transducerModelVoltage2Id: number;
  transducerModelVoltage3Id: number;
  transducerModelCurrent1Id?: number | null;
  transducerModelCurrent2Id?: number | null;
  transducerModelCurrent3Id?: number | null;
  voltageLevelId: number;
  connectionPoint: ApiDatabaseCommonConnectionPointType;
  activeFrom: string;
  activeTo?: string | null;
  comment: string;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementPointExternalDto;
  externalDtos?: ApiCommonExternalDtoMeasurementPointExternalDto[] | null;
};
export type ApiCommonExternalDtoMeasurementPointVersionExternalDto = {
  id?: number;
  tsoId?: number;
  name: string;
  technicalName: string;
  substationId: number;
  transducerModelVoltage1Id: number;
  transducerModelVoltage2Id: number;
  transducerModelVoltage3Id: number;
  transducerModelCurrent1Id?: number | null;
  transducerModelCurrent2Id?: number | null;
  transducerModelCurrent3Id?: number | null;
  voltageLevelId: number;
  connectionPoint: ApiDatabaseCommonConnectionPointType;
  activeFrom: string;
  activeTo?: string | null;
  measurementPointId: number;
  comment: string;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementPointVersionExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementPointVersionExternalDto;
  externalDtos?: ApiCommonExternalDtoMeasurementPointVersionExternalDto[] | null;
};
export type ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementPointExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementPointExternalDto;
};
export const {
  useGetMeasurementPointByIdQuery,
  useLazyGetMeasurementPointByIdQuery,
  useDeleteMeasurementPointByIdMutation,
  useGetMeasurementPointGetAllQuery,
  useLazyGetMeasurementPointGetAllQuery,
  useGetMeasurementPointGetAllBySubstationQuery,
  useLazyGetMeasurementPointGetAllBySubstationQuery,
  useGetMeasurementPointGetPastVersionsByTechnicalNameQuery,
  useLazyGetMeasurementPointGetPastVersionsByTechnicalNameQuery,
  useGetMeasurementPointByIdIsReferencedQuery,
  useLazyGetMeasurementPointByIdIsReferencedQuery,
  useGetMeasurementPointByIdHasDataQuery,
  useLazyGetMeasurementPointByIdHasDataQuery,
  useGetMeasurementPointByIdHasDataForCurrentVersionQuery,
  useLazyGetMeasurementPointByIdHasDataForCurrentVersionQuery,
  usePostMeasurementPointNewVersionByMeasurementPointTechnicalNameMutation,
  usePostMeasurementPointMutation,
  usePutMeasurementPointMutation,
} = injectedRtkApi;
